import { Model } from '@/clients/http'
import { stringifyGraph } from '@/clients/http/utils'
import { createResourceApi } from '@/http/models/Resource'

export interface BranchOption {
  _id: string
  name: string
}

export interface Branch {
  _id: string
  name: string
  address: string
  email?: string
  contact_number?: string
  type: 'branch' | 'warehouse'
  is_main: boolean
  status: 'active' | 'inactive'
  staff_ids?: string[]
  staffs?: { _id: string; name: string; email?: string; phone?: string }[]
}

type ErrorBody = { message?: string }

const crud = createResourceApi<Branch>('/api/backoffice/branch', 'BRANCH')

export class BranchModel extends Model {
  public static readonly correlations = {
    GET_OPTIONS: 'GET_BRANCH_OPTIONS',
    ADD_STAFF: 'ADD_BRANCH_STAFF',
    REMOVE_STAFF: 'REMOVE_BRANCH_STAFF',
  }

  public static readonly getOptions = async () =>
    this.createHttpRequest<{ result: BranchOption[]; count: number }, ErrorBody>({
      correlationKey: this.correlations.GET_OPTIONS,
      payload: {
        method: 'get',
        url: this.createEndpoint({
          url: '/api/backoffice/branch',
          query: { length: 200, graph_enc: stringifyGraph({ _id: true, name: true }) },
        }),
        useBearerToken: true,
      },
    })

  // Branches page (checklist C22).
  public static readonly getList = crud.getList
  public static readonly create = crud.create
  public static readonly update = crud.update
  public static readonly remove = crud.remove

  public static readonly addStaff = async (id: string, staffId: string) =>
    this.createHttpRequest<{ result: Branch }, ErrorBody>({
      correlationKey: this.correlations.ADD_STAFF,
      payload: {
        method: 'patch',
        url: this.createEndpoint({ url: '/api/backoffice/branch/:id/add-staff', params: { id } }),
        body: { staff_id: staffId },
        useBearerToken: true,
      },
    })

  public static readonly removeStaff = async (id: string, staffId: string) =>
    this.createHttpRequest<{ result: Branch }, ErrorBody>({
      correlationKey: this.correlations.REMOVE_STAFF,
      payload: {
        method: 'patch',
        url: this.createEndpoint({ url: '/api/backoffice/branch/:id/remove-staff', params: { id } }),
        body: { staff_id: staffId },
        useBearerToken: true,
      },
    })
}
